import type { ResolvedBranding } from '@command-center/ui-system';
import { adminConfig } from './config';

export type { ResolvedBranding };

/**
 * Returns the branding shape the legacy AppShell/Sidebar already consume.
 * Falls back to the historical "One Up / 1U / Hi" values if the config is
 * missing optional fields, so the UI never goes blank during transition.
 */
export function getBranding(): ResolvedBranding {
  const branding = adminConfig.branding;
  return {
    name: branding.name || 'One Up Command Center',
    shortLabel: adminConfig.clientName || 'One Up',
    iconText: branding.icon || '1U',
    shortSuffix: 'Hi',
    colors: branding.colors,
  };
}
